module.exports = __webpack_public_path__ + "static/img/triangle-down.59ad0edb.svg";